import { Action, createReducer } from "@ngrx/store";
import {
  createEmptyQuoteFeatureState,
  QuoteFeatureState,
} from "../quote.state";

const reducer = createReducer(
  createEmptyQuoteFeatureState(),
  ///////////////////////////////////////////////////////////////////////////////
  // Quote - Business Actions
  ///////////////////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////////////////////////////////////
  // Term Life Insurance - Chain Reaction Actions
  ///////////////////////////////////////////////////////////////////////////////
);

export function featureReducer(
  state: QuoteFeatureState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
